"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacterUtils = exports.staticCharacterSchema = exports.characterVariablesMapSchema = exports.characterVariablesInnerMapSchema = exports.characterVariableNameSchema = exports.characterVariablesSchema = void 0;
var joi = __importStar(require("joi"));
var geo_1 = require("../geo");
var object_1 = require("../utils/object");
var character_basics_1 = require("./character-basics");
var player_1 = require("./player");
var spell_1 = require("./spell");
var characterVariablesSchemaContent = {
    health: joi.number().required().integer().min(0),
    actionTime: joi.number().required().integer().min(0),
    position: geo_1.positionSchema,
    orientation: geo_1.orientationSchema
};
exports.characterVariablesSchema = joi.object(characterVariablesSchemaContent);
exports.characterVariableNameSchema = object_1.ObjectTyped.keys(characterVariablesSchemaContent);
exports.characterVariablesInnerMapSchema = joi.object({})
    .pattern(character_basics_1.characterIdSchema, joi.any());
exports.characterVariablesMapSchema = joi.object({})
    .pattern(exports.characterVariableNameSchema, exports.characterVariablesInnerMapSchema);
exports.staticCharacterSchema = joi.object({
    characterId: character_basics_1.characterIdSchema,
    playerId: player_1.playerIdSchema,
    characterRole: character_basics_1.characterRoleSchema,
    defaultSpellId: spell_1.spellIdSchema
});
var CharacterUtils;
(function (CharacterUtils) {
    CharacterUtils.isAlive = function (health) { return health > 0; };
})(CharacterUtils = exports.CharacterUtils || (exports.CharacterUtils = {}));
